<template>
    <div style="" class="loading" v-if="isLoading">
      <span>
        <div class="spinner-border text-light" role="status"></div>Loading...
        <!--
        <div class="loading-img"></div>Loading...
        -->
      </span>
    </div>
    <div class="container-fluid">
      <div class="row">
        <!-- Sidebar Menu -->
        <div class="col-auto px-0">
          <div id="sidebar" ref="sidebar" class="sidebar collapse-horizontal border-end collapse show" style="">
            <ul class="list-group no-markers" id="menu">
              <li v-for="item in menuData" :key="item.id" @click="selectMenuItem(item)">
                <a v-if="!item.menu || item.menu.length==0" href="#" class="nav-link px-0 custom-link">
                  <i class="fs-4 bi-circle-fill"></i>
                  <span class="ms-1 d-sm-inline">{{ item.name }}</span>
                </a>

                <a v-else-if="item.menu.length>1" :href="`${'#'+item.name+'submenu'}`" @click.prevent="toggleCollapse(item.name + 'submenu')" class="nav-link px-0 custom-link">
                  <i class="fs-4 bi-circle-fill"></i>
                  <span class="ms-1 d-sm-inline">{{ item.name }}</span>
                  <i :class="['float-end fs-4', { 'bi-chevron-down': isCollapsed(item.name + 'submenu') }, { 'bi-chevron-up': !isCollapsed(item.name + 'submenu') }]"></i>
                </a>

                
                <ul v-if="item.menu && item.menu.length>1" class="collapse nav flex-column ms-1" :id="item.name+'submenu'" data-bs-parent="#menu">
                  <li class="w-100 align-items-center" v-for="subItem in item.menu" :key="subItem.id" @click.stop="selectSubMenuItem(subItem, item)">
                    <a href="#" class="nav-link px-0 sub-menu"> <span class="d-sm-inline">{{ subItem.name }}</span></a>
                  </li>
                </ul>
              </li>
              
              <!--
              <li class="list-group-item" v-for="item in menuData" :key="item.id" @click="selectMenuItem(item)">
                {{ item.name }}
                <ul class="list-group" v-if="item.menu">
                  <li class="list-group-item" v-for="subItem in item.menu" :key="subItem.id" @click.stop="selectSubMenuItem(subItem, item)">
                    {{ subItem.name }}
                    <ul class="list-group" v-if="subItem.menu">
                      <li class="list-group-item" v-for="tab in subItem.menu" :key="tab.id" @click.stop="selectTab(tab, subItem)">
                        {{ tab.name }}
                      </li>
                    </ul>
                  </li>
                </ul>
              </li>
              -->
            </ul>
            <button v-if="menuData" class="btn btn-outline-success d-block mt-2" type="button" @click="loadStatsPage">Stats</button>
            <button class="btn btn-outline-success d-block" type="button" @click="loadDeviceList">Device List</button>
          </div>
        </div>
  
        <!-- Navbar -->
        <main class="col ps-md-2 pt-2">
          <nav class="navbar navbar-light" style="background-color: #e3f2fd;">
          <!--
          <nav class="navbar navbar-expand-lg navbar-light bg-light">
          -->
            <div class="container-fluid">
              <a href="#" @click.prevent="toggleSidebar" class="border rounded-3 p-1 text-decoration-none" ><i class="bi bi-list bi-lg py-2 p-1"></i> Menu</a>
              <a class="navbar-brand">{{ modelname }}</a>
              <!--
              <form class="justify-content-center" v-if="menuData">
                <button class="btn btn-outline-success me-2" type="button" @click="showUpgrade()">Upgrade</button>
                <button class="btn btn-outline-success" type="button" @click="">Profile</button>
              </form>
              -->
            </div>
          </nav>
        
  
          <!-- Content Area -->
          <div class="content mt-3">
            <div v-if="selectedSubMenuItem && selectedSubMenuItem.menu">
              <ul class="nav nav-tabs">
                <li class="nav-item" v-for="tab in selectedSubMenuItem.menu" :key="tab.id">
                  <a class="nav-link" href="#" :class="{ active: selectedTabItem && selectedTabItem.id === tab.id }" @click="selectTab(tab, selectedSubMenuItem)">{{ tab.name }}</a>
                </li>
              </ul>
            </div>
            <template v-if="selectedForm">
              <div>
                <form @submit.prevent="submitForm">

                  <!--
                  <component v-for="(item, index) in selectedForm" :key="index" :is="getFieldComponent(item.type)" :item="item" v-show="item.isVisible" @updateValue="updateValue" />
                  -->
                  <component v-for="(item, index) in selectedForm" :key="index" :is="getFieldComponent(item.type)" :item="item" @updateValue="updateValue" @buttonClick="buttonClick" @error="handleError"/>
                  <!--
                  <div v-for="(item, index) in selectedForm" :key="index" class="mb-3">
                    <label :for="item.id" class="form-label">{{ item.name }}</label>
                    <component :is="getFieldComponent(item.type)" :item="item"></component>
                  </div>
                  <button type="submit" class="btn btn-primary">Submit</button>
                  -->
                </form>
              </div>
            </template>
            <template v-if="statsData" >
              <component :is="CStatsPage" :item="statsData" @load-finished="() => {console.log('load-finished event');isLoading = false;}" />
            </template>
          </div>
        </main>
      </div>
    </div>
  </template>
  
  <script>
  import axios from 'axios'
  import { ref, onMounted, nextTick, watch } from 'vue'
  import { getCurrentInstance } from 'vue'
  import { useRoute, useRouter } from 'vue-router'
  import { Collapse } from 'bootstrap';
  import SelectField from './SelectField.vue';
  import TextField from './TextField.vue';
  import CheckboxField from './CheckboxField.vue';
  import ButtonField from './ButtonField.vue';
  import RadioField from './RadioField.vue';
  import StatsPage from './StatsPage.vue';
  import { Preferences } from '@capacitor/preferences'
  
  
  export default {
    components: {
      StatsPage,
    },
    setup() {
      const currentInstance = getCurrentInstance()
      const PhiveHost = currentInstance.appContext.config.globalProperties.PhiveHost
      const token = ref(localStorage.getItem('token'))
      const devid = useRoute().params.devid
      const modelname = history.state.modelname
      const menuData = ref(null)
      const selectedTabItem = ref(null)
      const selectedSubMenuItem = ref(null)
      const selectedTopMenuItem = ref(null)
      const selectedForm = ref(null)
      const tmpForm = ref(null)
      const tmpStats = ref(null)
      const fwData = ref([])
      const currentItemid = ref(null)
      const router = useRouter()
      const collapseStates = ref({})
      const sidebar = ref(null);
      const isLoading = ref(false)
      const showstats = ref(false)
      const statsData = ref(null)
      const isMobile = ref(false)

      const newMenuItem = {
        "name": "Maintenance",
        "menu": [
          {
            "name": "Upgrade",
            "id": "my/sys/upgrade"
          },
          {
            "name": "Profile",
            "id": "my/sys/profile"
          }
        ]
      };
      const manual_upgrade_only = [
        { "type": "text", "name": "FW URL", "id": "upgrade.url" },
        { "type": "text", "name": "FW Ver", "id": "upgrade.ver" },
        { "type": "text", "name": "FW Digest", "id": "upgrade.digest" },
        { "type": "save", "name": "Upgrade", "id": "upgrade.submit" },
      ];
      const full_upgrade = [
        { "type": "radio", "name": "Auto", "id": "upgrade.mode", "value": "1",
          "options": [{"name":"From Server", "value":"1"}, {"name":"Manual", "value":"0"}]},
        { "type": "select", "name": "FW ver", "id": "srv.upgrade.ver",
          "options": [], "depends": [{"upgrade.mode": "1"}]},
        { "type": "text", "name": "FW URL", "id": "upgrade.url", "depends": [{"upgrade.mode": "0"}]},
        { "type": "text", "name": "FW Ver", "id": "upgrade.ver", "depends": [{"upgrade.mode": "0"}]},
        { "type": "text", "name": "FW Digest", "id": "upgrade.digest", "depends": [{"upgrade.mode": "0"}]},
        { "type": "save", "name": "Upgrade", "id": "upgrade.submit" },
      ];
      const manual_profile = [
        { "type": "text", "name": "Profile URL", "id": "profile.url" },
        { "type": "save", "name": "Profile Upload", "id": "profile.set" },
        { "type": "save", "name": "Profile Get", "id": "profile.get" },
      ];


      let CStatsPage = ref('StatsPage');
      
      const fieldComponents = {
        select: SelectField,
        text: TextField,
        bool: CheckboxField,
        radio: RadioField,
        apply: ButtonField,
        save: ButtonField,
      };

      const ToLoginPage = async (clean) => {
        await Preferences.remove({ key: 'username' });
        await Preferences.remove({ key: 'password' });
        localStorage.removeItem('token')
        router.push('/login')
      };

      const toggleSidebar = () => {
        console.log("toggleSidebar 1");
        if (sidebar.value) {
          console.log("toggleSidebar 2");
          const collapseInstance = Collapse.getInstance(sidebar.value);
          if (collapseInstance) {
            console.log("toggleSidebar 3");
            collapseInstance.toggle();
          } else {
            console.log("toggleSidebar 4");
            new Collapse(sidebar.value, {
              toggle: true,
              show: true
            });
          }
        }
      };

      const getFieldComponent = (type) => {
        return fieldComponents[type] || null;
      };

      const isCollapsed = (id) => {
        return collapseStates.value[id] !== true;
      };

      const toggleCollapse = (id) => {
        console.log("toggleCollapse ", id);
        nextTick(() => {
          const collapseElements = document.querySelectorAll('#menu .collapse');
          const collapseElement = document.getElementById(id);
          if (collapseElement) {
            let bsCollapse;
            bsCollapse = Collapse.getInstance(collapseElement);
            if(!bsCollapse)
              bsCollapse = new Collapse(collapseElement);
            bsCollapse.toggle();
            collapseStates.value[id] = collapseStates.value[id] === undefined ? true : !collapseStates.value[id];

            collapseElements.forEach((element) => {
              if(element.id != id) {
                collapseStates.value[element.id] = false;
              }
            });
          }
        });
      };

      const collapseAll = () => {
        console.log("collapseAll");
        nextTick(() => {
          const collapseElements = document.querySelectorAll('#menu .collapse');
          collapseElements.forEach((element) => {
            const collapseId = element.id;
            const bsCollapse = Collapse.getInstance(element);
            if(bsCollapse) {
              bsCollapse.hide();
              collapseStates.value[collapseId] = false;
            }
          });
        });
        
      };

      const loadDeviceList = () => {
        router.push('/top')
      }

      const loadStatsPage = () => {
        collapseAll();
        selectedSubMenuItem.value = null;
        selectedForm.value = null;
        showstats.value = true;
        statsData.value = null;
        if(isMobile.value)
          toggleSidebar()
        fetchStatsList();
      };

      const shouldShowComponent = (item) => {
        if (!item.depends) {
          return true; // 如果沒有相依，則一直顯示
        }

        // 遍歷所有相依條件，檢查是否符合
        for (const condition of item.depends) {
          const [dependId, dependValue] = Object.entries(condition)[0];
          const dependField = selectedForm.value.find((field) => field.id === dependId);
          if (dependField) {
            if (dependField.value === null || dependField.value === undefined){}
            else if (dependField.value !== dependValue) {
              return false; // 如果有不匹配的相依條件，則隱藏
            }
          }
        }

        return true; // 如果所有相依條件都匹配，則顯示
      };

      const fetchStatsData = async () => {
        if (!token.value) {
          //alert('Please login first')
          //router.push('/login')
          ToLoginPage(1)
          return
        }
  
        try {
          let data = {};
          let list = [];
          data['token'] = token.value;
          tmpStats.value.forEach((item) => {
            list.push(item.id);
          });
          data['list'] = list;
          const response = await axios.post(PhiveHost+'/cgi-bin/statget.cgi/'+devid, data, { headers: { 'Content-Type': 'application/json' } })
          if ('code' in response.data && response.data.code !== 0) {
            alert(response.data.msg || 'Failed to fetch stat value')
          } else {
            console.log("response stat data ", response.data.list);
            tmpStats.value.forEach(item => {
              const target = response.data.list.find(stat => stat.id === item.id);
              if (target)
                item.value = target.value;
            });
            console.log("statsData ", tmpStats.value)
          }

          

        } catch (error) {
          console.error(error)
          alert('Failed to fetch stats value')
        } finally {
          statsData.value = tmpStats.value
          isLoading.value = false;
        }
      }

      const fetchStatsList = async () => {
        if (!token.value) {
          //alert('Please login first')
          //router.push('/login')
          ToLoginPage(1)
          return
        }

        isLoading.value = true;
        statsData.value = null;
  
        try {
          const response = await axios.post(PhiveHost+'/cgi-bin/statlist.cgi/'+devid, { token: token.value }, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } })
          if ('code' in response.data && response.data.code !== 0) {
            if (response.data.code === -14) {
              isLoading.value = false;
              router.push('/login')
            }
            else {
              alert(response.data.msg || 'Failed to fetch stats data')
            }
          }
          else {
            tmpStats.value = response.data.root;
            fetchStatsData();
          }
        } catch (error) {
          isLoading.value = false;
          console.error(error)
          alert('Failed to fetch stats data')
        } finally {
          //isLoading.value = false;
        }
      }

  
      const fetchMenuData = async () => {
        if (!token.value) {
          //alert('Please login first')
          //router.push('/login')
          ToLoginPage(1)
          return
        }

        isLoading.value = true;
  
        try {
          const response = await axios.post(PhiveHost+'/cgi-bin/pagelist.cgi/'+devid, { token: token.value }, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } })
          if ('code' in response.data && response.data.code !== 0) {
            if (response.data.code === -14) {
              isLoading.value = false;
              router.push('/login')
            }
            else {
              alert(response.data.msg || 'Failed to fetch menu data')
            }
          }
          else {
            menuData.value = response.data.menu
            menuData.value.push(newMenuItem);
          }
        } catch (error) {
          console.error(error)
          alert('Failed to fetch menu data')
        } finally {
          isLoading.value = false;
        }
      }

      const fetchFormValue = async (itemId) => {
        if (!token.value) {
          //alert('Please login first')
          //router.push('/login')
          ToLoginPage(1)
          return
        }
        //isLoading.value = true;
  
        try {
          const response = await axios.post(PhiveHost+'/cgi-bin/pageget.cgi/'+devid+'/'+itemId, { token: token.value }, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } })
          if ('code' in response.data && response.data.code !== 0) {
            alert(response.data.msg || 'Failed to fetch form value')
          } else {
            console.log("get formvalue ", response.data)
            tmpForm.value.forEach(item => {
              if (response.data[item.id]) {
                item.value = response.data[item.id];
              }
            });
            console.log("append value ", tmpForm.value)
          }

          

        } catch (error) {
          console.error(error)
          alert('Failed to fetch form value')
        } finally {
          selectedForm.value = tmpForm.value
          isLoading.value = false;
        }
      }
  
      const fetchFormData = async (itemId) => {
        if (!token.value) {
          //alert('Please login first')
          //router.push('/login')
          ToLoginPage(1)
          return
        }
        isLoading.value = true;
        currentItemid.value = itemId;
  
        try {
          const response = await axios.post(PhiveHost+'/cgi-bin/pagedesc.cgi/'+devid+'/'+itemId, { token: token.value }, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } })
          if ('code' in response.data && response.data.code !== 0) {
            isLoading.value = false;
            if (response.data.code === -14) {
              router.push('/login')
            }
            else {
              alert(response.data.msg || 'Failed to fetch form data')
            }
          } else {        
            tmpForm.value = response.data.root
            fetchFormValue(itemId)
          }
        } catch (error) {
          isLoading.value = false;
          console.error(error)
          alert('Failed to fetch form data')
        } finally {
          //isLoading.value = false;
        }
      }

      const fetchFWList = async () => {
        if (!token.value) {
          //alert('Please login first')
          //router.push('/login')
          ToLoginPage(1)
          return
        }

        isLoading.value = true;
        fwData.value = []
        const srvUpgradeVerField = full_upgrade.find(field => field.id === "srv.upgrade.ver")
        if (srvUpgradeVerField) {
          srvUpgradeVerField.options = []
        }

        try {
          const response = await axios.post(PhiveHost+'/cgi-bin/fwlist.cgi', { token: token.value, model: modelname }, { headers: {'Content-Type': 'application/x-www-form-urlencoded'}})
          if (response.data.code === 0) {
            if(response.data.fws.length > 0) {
              fwData.value = response.data.fws
              if(srvUpgradeVerField)
                srvUpgradeVerField.options = response.data.fws.map(fw => ({"name": fw.version, "value": fw.version}))
            }
          } else {
            ToLoginPage(1)
          }
          
        } catch (error) {
          console.error(error)
          alert('Failed to fetch fw list')
        } finally {
          if(!srvUpgradeVerField || srvUpgradeVerField.options.length==0)
            selectedForm.value = [...manual_upgrade_only]
          else
            selectedForm.value = [...full_upgrade]
          isLoading.value = false;
        }
      }

      const fetchFwProfileFormData = async (itemId) => {
        

        if(itemId == "my/sys/upgrade") {
          fetchFWList();
        }
        else
          selectedForm.value = /*(itemId==="my/sys/upgrade")?manual_upgrade:*/manual_profile;
      }
  
      const selectMenuItem = (item) => {
        let id = ""
        if (item.id) {
          id = item.id
        }
        else if(item.menu.length==1 && item.menu[0].id) {
          id = item.menu[0].id;
        }
        if(id !== "") {
          selectedTopMenuItem.value = item
          selectedSubMenuItem.value = null
          selectedTabItem.value = null
          selectedForm.value = null
          showstats.value = false
          statsData.value = null

          if(isMobile.value)
            toggleSidebar()
          fetchFormData(id)
        }
      }
  
      const selectSubMenuItem = (subItem, parentItem) => {
        let id = ""
        console.log(subItem.menu)
        if(subItem.id)
         id = subItem.id
        else if(subItem.menu.length>0 && subItem.menu[0].id) {
          id = subItem.menu[0].id
          selectedTabItem.value = subItem.menu[0]
        }
        if(id !== "") {
          console.log("isMobile ", isMobile.value);
          if (isMobile.value) {
            toggleSidebar()
          }
          selectedSubMenuItem.value = subItem
          selectedForm.value = null
          showstats.value = false
          statsData.value = null
          if(id==="my/sys/upgrade" || id==="my/sys/profile")
            fetchFwProfileFormData(id)
          else
            fetchFormData(id)
        } else {
          //selectTab(subItem, null)
        }
      }

      
  
      const selectTab = (tab, parentItem) => {
        selectedForm.value = null
        showstats.value = false;
        statsData.value = null;
        selectedTabItem.value = tab
        if (!parentItem || !parentItem.id) {
          fetchFormData(tab.id)
        } else {
          fetchFormData(parentItem.id)
        }
      }

      const updateValue = (data) => {
        const field = selectedForm.value.find((field) => field.id === data.id);
        if (field) {
          if(data.error==true) {
            console.error(`Validation error for ${field.name}: ${data.errorMessage}`);
          }
          console.log("update ", field);
          field.value = data.value;
          field.error = data.error==undefined ? false : data.error;
        }
      };

      const handleError = (data) => {
        /*
        console.error(`Validation error for ${data.item.name}: ${data.errorMessage}`);
        const field = selectedForm.value.find((field) => field.id === data.item.id);
        console.log("0 ", field);
        field.error = true;
        console.log("1 ", field);
        */
      }

      const submitFormValue = async (btn) => {
        const field = selectedForm.value.find((field) => field.error === true);
        if(field)
          return;

        if (!token.value) {
          //alert('Please login first')
          //router.push('/login')
          ToLoginPage(1)
          return
        }
        isLoading.value = true;
  
        try {
          let data = {};
          let config = {};
          data['token'] = token.value;
          data['mode'] = btn.type === "apply" ? "apply" : "save";
          data['pages'] = btn.pages ?? [];
          selectedForm.value.forEach((item) => {
            config[item.id] = item.value;
          });
          data['config'] = config;

          const response = await axios.post(PhiveHost+'/cgi-bin/pageset.cgi/'+devid+'/'+currentItemid.value, data, { headers: { 'Content-Type': 'application/json' } })
          if ('code' in response.data && response.data.code !== 0) {
            if (response.data.code === -14) {
              isLoading.value = false;
              router.push('/login')
            }
            else {
              alert(response.data.msg || 'Failed to set value')
            }
          } else {
            console.log("get formvalue ", response.data)
          }
        } catch (error) {
          console.error(error)
          alert('Failed to submit form value')
        } finally {
          isLoading.value = false;
        }
      }

      const get_filename = (contentDisposition) => {
        if (contentDisposition) {
          const filenameRegex = /filename="?([^"]+)"?/;
          const match = filenameRegex.exec(contentDisposition);
          if (match && match[1]) {
            const filename = match[1];
            return filename;
          }
        }
        return "mytest.bin"
      }

      const submitUpgProf = async (btn) => {
        if (!token.value) {
          //alert('Please login first')
          //router.push('/login')
          ToLoginPage(1)
          return
        }
        isLoading.value = true;
  
        try {
          let data = {};
          let cgi="";
          console.log("selectedForm ", selectedForm.value)
          data['token'] = token.value;
          if(btn.id==="upgrade.submit") {
            data['mode'] = selectedForm.value.find(formItem => formItem.id === "upgrade.mode")?.value;
            if(data['mode']==='1') {
              let version = selectedForm.value.find(formItem => formItem.id === "srv.upgrade.ver")?.value
              data['url'] = fwData.value.find(item => item.version === version)?.url
              data['ver'] = version
              data['type'] = "fw";
              data['digest'] = fwData.value.find(item => item.version === version)?.md5
            }
            else {
              data['url'] = selectedForm.value.find(formItem => formItem.id === "upgrade.url")?.value;
              data['ver'] = selectedForm.value.find(formItem => formItem.id === "upgrade.ver")?.value;
              data['type'] = "fw";
              data['digest'] = selectedForm.value.find(formItem => formItem.id === "upgrade.digest")?.value;
            }
            cgi = "upgrade.cgi"
          }
          else if(btn.id==="profile.set") {
            data['url'] = selectedForm.value.find(formItem => formItem.id === "profile.url")?.value;
            cgi = "proset.cgi"
          }
          else if(btn.id==="profile.get") {
            cgi = "proget.cgi"
          }

          const response = await axios.post(PhiveHost+'/cgi-bin/'+cgi+'/'+devid, data, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } })
          if (response.headers['content-type'] === 'application/json' && response.data.code !== 0) {
            if (response.data.code === -14) {
              isLoading.value = false;
              router.push('/login')
            }
            else {
              if (cgi === "upgrade.cgi") {
                alert(response.data.msg || 'Upgrade failed')
              }
              else if (cgi === "proset.cgi") {
                alert(response.data.msg || 'Failed to set profile')
              }
              else {
                alert(response.data.msg || 'Failed to get profile')
              }
            }

          } else if (response.headers['content-type'] === 'application/octet-stream') {
            const filename = get_filename(response.headers['content-disposition'])
            const blob = new Blob([response.data], { type: 'application/octet-stream' });
            const url = window.URL.createObjectURL(blob);
            // Trigger file download
            const a = document.createElement('a');
            a.href = url;
            a.download = filename; // Set the desired filename
            document.body.appendChild(a);
            a.click();
            a.remove();
            window.URL.revokeObjectURL(url);
          }
          else if(response.headers['content-type'] === 'application/json' && response.data.code === 0) {
            if (cgi === "upgrade.cgi") {
              alert("Upgrade starting.");
            }
          }
          else {
            alert('Failed to get file')
          }
        } catch (error) {
          console.error(error)
          alert('Failed to submit form value')
        } finally {
          isLoading.value = false;
        }
      }

      const buttonClick = (btn) => {
        console.log("click ", btn.id, btn.name)
        if(btn.id==="upgrade.submit"||btn.id==="profile.set"||btn.id==="profile.get")
          submitUpgProf(btn)
        else
          submitFormValue(btn)
      };

      const submitForm = () => {
        /*
        selectedForm.value.forEach((item) => {
          console.log('id:', item.id, 'value:', item.value);
        });
        */
      }

      const checkMobile = () => {
        isMobile.value = window.innerWidth <= 767.98;
      }

      const handleClickOutside = (event) => {
        if (!isMobile.value || !sidebar.value || !sidebar.value.classList.contains('show')) {
          return;
        }
        if (!sidebar.value.contains(event.target)) {
          toggleSidebar()
        }
      }

  
      onMounted(() => {
        console.log("showDevice devid", devid);

        window.addEventListener('resize', checkMobile);
        document.addEventListener('click', handleClickOutside);
        checkMobile()
        
        fetchMenuData()
        nextTick(() => {
          const collapseElements = document.querySelectorAll('#menu .collapse');
          const collapses = [...collapseElements].map(element => new Collapse(element));

          collapseElements.forEach(element => {
          collapseStates.value[element.id] = element.classList.contains('show');
          //toggleSidebar()
        });
        });
      })

      watch(
        () => selectedForm.value?.map((item) => item.value),
        () => {
          // 在這裡重新評估所有元件的顯示與隱藏
          if (selectedForm.value) {
            selectedForm.value.forEach((item) => {
              item.isVisible = shouldShowComponent(item);
            });
          }
        },
        { deep: true }
      );
      watch(showstats, (newValue) => {
        console.log('showstats updated to:', newValue)
      })

      /*
      watch(selectedTabItem, (newTab) => {
        if (newTab && newTab.id) {
          fetchFormData(newTab.id)
        }
      })
        */
  
      return {
        menuData,
        selectedTabItem,
        selectedSubMenuItem,
        selectedForm,
        selectMenuItem,
        selectSubMenuItem,
        selectTab,
        getFieldComponent,
        toggleCollapse,
        isCollapsed,
        sidebar,
        toggleSidebar,
        isLoading,
        modelname,
        shouldShowComponent,
        updateValue,
        handleError,
        buttonClick,
        submitForm,
        showstats,
        loadStatsPage,
        loadDeviceList,
        CStatsPage,
        statsData,
        ToLoginPage,
        fetchFWList,
      }
    }
  }
  </script>


<style>

.sidebar {
  height: 100vh;
  background-color: #ffffff;
  padding: 1rem;
}

@media (max-width: 767.98px) { /* Bootstrap's md breakpoint */
  #sidebar {
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    z-index: 1000;
    background: rgb(255, 255, 255); /* or your desired background color */
  }
  
  /* Add padding to main content when sidebar is shown */
  .sidebar.show + main {
    margin-left: 250px; /* adjust based on your sidebar width */
  }
  
  /* Reset margin when sidebar is collapsed */
  .sidebar.collapse:not(.show) + main {
    margin-left: 0;
  }
  
  /* Smooth transition */
  main {
    transition: margin-left 0.3s ease-in-out;
  }
}

/*
.nav-link {
  cursor: pointer;
}
  */

.collapsed .sub-menu {
  display: none;
}

.expanded .sub-menu {
  display: block;
}

.sub-menu {
  padding-left: 2rem;
  text-align: center;
}

.rotate {
  transform: rotate(90deg);
}

.rotate-up {
  transform: rotate(180deg) !important;
}

.no-markers {
  list-style-type: none;
  padding-left: 0;
}


.custom-link {
  display: flex;
  align-items: center; /* 垂直居中對齊 */
  justify-content: space-between; /* 水平分隔對齊 */
  width: 100%; /* 確保父元素有寬度 */
}

.custom-link i {
  margin-left: 0; /* 移除 bi-circle-fill 的左邊距 */
}

.custom-link span {
  flex-grow: 1; /* 讓 span 項佔據中間的空間 */
  text-align: left; /* 將 span 項靠左對齊 */
}

.custom-link i.float-end {
  margin-right: 0; /* 移除 bi-chevron-up 的右邊距 */
}

.loading > span {
  font-family: 'icomoon' !important;
  speak: none;
  font-style: normal !important;
  font-weight: normal !important;
  font-variant: normal !important;
  text-transform: none !important;
  line-height: 1;

  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.loading {
  position: fixed;
  width: 100%;
  height: 100%;
  z-index: 1000;
  display: block;
  background-color: #4f5868c9;
  top: 0;
}

.loading > span {
  display: block;
  text-align: center;
  color: white;
  font-size: 1.2rem;
  top: 10%;
  position: absolute;
  width: 100%;
}

.loading > span > .loading-img:before {
  font-family: "icomoon";
  content: "\e603";
  font-size: 64px; /* Adjust the size as needed */
  vertical-align: middle;
}

.loading > span > .loading-img {
  animation: anim-rotate 2s infinite linear;
  margin-right: 0.2rem;
  display: inline-block;
}

@keyframes anim-rotate {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

</style>
